import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

const AvailableProfessionalsForJobGql = graphql(`
  query GetAvailableProfessionalsForJob($input: ProfessionalQueryInput) {
    availableProfessionalsForShiftSwap(input: $input) {
      id
      name
      account_id
    }
  }
`);

type AvailableProfessionalsForJobProps = ResultOf<typeof AvailableProfessionalsForJobGql>;

export const useSwapProfessionalsList = ({
  jobId,
  locationId,
}: {
  jobId?: number | null;
  locationId?: number | null;
}) => {
  const { data, isLoading } = useGraphQLQuery<AvailableProfessionalsForJobProps>({
    operationName: 'GetAvailableProfessionalsForJob',
    query: AvailableProfessionalsForJobGql,
    enabled: !!jobId,
    variables: {
      input: {
        search: {
          available_for_job_id: Number(jobId),
          location_ids: locationId ? [locationId] : [],
        },
      },
    },
  });
  const availableProfessionals = data?.availableProfessionalsForShiftSwap ?? [];

  return { availableProfessionals, isLoading };
};
